import { createFileRoute } from '@tanstack/react-router';
import { TrustLayout } from '../../components/trust/TrustLayout';
import { SandboxPanel } from '../../components/trust/SandboxPanel';

export const Route = createFileRoute('/trust/sandbox')({
  component: SandboxPage,
});

function SandboxPage() {
  return (
    <TrustLayout>
      <h1 className="mt-0 text-[22px] text-black">Sandbox</h1>
      <SandboxPanel />
    </TrustLayout>
  );
}
